// extracted by mini-css-extract-plugin
export default {"advertDetailService__label":"c-o_fE","advertDetailService__price":"c-o_fF"};